(() => {
  document.addEventListener('click', async (event) => {
    const copy = event.target.closest('.arcis-copy-offer');
    if (copy) {
      const status = copy.closest('.arcis-offer-strip').querySelector('.arcis-offer-status');
      try {
        await navigator.clipboard.writeText(copy.dataset.offerCode);
        copy.querySelector('span').textContent = 'Copied!';
        status.textContent = copy.dataset.offerCode + ' copied. Enter it at checkout.';
        window.setTimeout(() => { copy.querySelector('span').textContent = copy.dataset.offerCode; }, 1800);
      } catch (_) { status.textContent = 'Use code ' + copy.dataset.offerCode + ' at checkout.'; }
      return;
    }
    const swatch = event.target.closest('[data-arcis-variant]');
    if (!swatch || !swatch.dataset.arcisVariant) return;
    const card = swatch.closest('.grid-view-item');
    const input = card?.querySelector('.details .product-form input[name="id"]');
    if (!input) return;
    queueMicrotask(() => {
      input.value = swatch.dataset.arcisVariant;
      input.setAttribute('value', swatch.dataset.arcisVariant);
    });
    card.querySelectorAll('[data-arcis-variant]').forEach(el => el.setAttribute('aria-pressed', String(el === swatch)));
    const price = card.querySelector('.priceWraper .pr_price:not(s)');
    const compare = card.querySelector('.priceWraper s.pr_price');
    if (price && swatch.dataset.arcisPrice) price.textContent = swatch.dataset.arcisPrice;
    if (compare) { compare.textContent = swatch.dataset.arcisCompare || ''; compare.hidden = !swatch.dataset.arcisCompare; }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-arcis-default-variant]');
    if (!form) return;
    const card = form.closest('.grid-view-item');
    const selected = card?.querySelector('[data-arcis-variant][aria-pressed="true"]');
    const id = selected?.dataset.arcisVariant || form.dataset.arcisDefaultVariant;
    if (id) { form.querySelector('input[name="id"]').value = id; }
  }, true);
  document.addEventListener('keydown', (event) => {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[data-arcis-variant]')) { event.preventDefault(); event.target.click(); }
  });
})();
